<script lang="ts">
	import { t } from '#lib/i18n/tranlsator.svelte.ts';
	import { globalState } from '#lib/util/global-state.svelte.ts';
	import { resolveInstance } from '#lib/util/resolve-links.ts';

	// For testing:
	// globalState.usageStatus = 'warn';
	// globalState.usageStatus = 'extra-credits';
	// globalState.usageStatus = 'exhausted';

	const plan = $derived(globalState.user.plan);
	const usageUrl = $derived(resolveInstance('/user-settings/usage'));
	const upgradeUrl = $derived(resolveInstance('/manage-plan'));
	const creditsUrl = $derived(resolveInstance('/buy-credits'));
	const roundedPercent = $derived(
		globalState.usagePercent !== null ? Math.round(globalState.usagePercent) : 0
	);
</script>

{#if globalState.usageStatus === 'warn'}
	<a href={usageUrl} class="usage-warning warn connected">
		<span>{t('plan.usageWarning', { percent: roundedPercent })}</span>
	</a>
{:else if globalState.usageStatus === 'extra-credits'}
	<a href={usageUrl} class="usage-warning warn connected">
		<span>{t('plan.extraCreditsInUse', { count: globalState.usageGrantBalance })}</span>
	</a>
{:else if globalState.usageStatus === 'exhausted' && globalState.billingEnabled}
	<div class="usage-warning exhausted connected">
		<span class="exhausted-text">{t('plan.creditsExhausted')}</span>
		{#if plan !== 'pro'}
			<a href={upgradeUrl} class="upgrade-link">
				{t('plan.upgrade')}
			</a>
		{/if}
		<a href={creditsUrl} class="upgrade-link">
			{t('billing.credits.buyMore')}
		</a>
	</div>
{/if}

<style lang="scss">
	@use '@astlai/common/styles/mixins' as lib;

	.usage-warning {
		@include lib.flex-row();
		@include lib.flex-align(flex-start, center);
		gap: 0.5rem;
		font-size: 0.75rem;
		padding: 0.5rem;
		border-radius: 0.5rem;
		text-decoration: none;

		&.connected {
			border-top: none;
			border-top-left-radius: 0;
			border-top-right-radius: 0;
			border-top: none;
			margin: 0 1rem;
		}

		&.warn {
			background: var(--surface-warning-subtle);
			color: var(--text-warning);
			border: 1px solid var(--surface-warning);
			border-top: none;
		}

		&.exhausted {
			background: var(--surface-error);
			color: var(--text-error);
			border: 1px solid var(--surface-error);

			.exhausted-text {
				flex: 1 1 auto;
			}

			.upgrade-link {
				margin-left: auto;
				color: var(--text-error);
				font-weight: 600;
				white-space: nowrap;

				&:hover {
					opacity: 0.8;
				}
			}
		}
	}
</style>
